import superagent from 'superagent'
import * as moment from 'moment-timezone'

import { backendUrl } from '../../helpers/consts.js'

export const movementTypeToReason = {
  CYCLE_COUNT: 'audit',
  SHIPMENT: 'picked',
  TRANSFER: 'transfer',
  RETURN: 'transfer',
  ADJUSTMENT: 'adjustment',
}

// Without dates the export would read every matching movement since 2021 ("picked" alone is
// ~150k rows), so, like the orders export, a missing date falls back to a 30-day window. The
// backend applies the same rule (approval services movement-history-csv withDefaultExportRange).
export const MOVEMENT_EXPORT_DEFAULT_RANGE_DAYS = 30

/** Whether the user picked a FROM or TO date. */
export const hasMovementDateRange = filters => Boolean(filters.fromDate || filters.toDate)

/**
 * The page's filters as the export should read them, always bounded in time:
 * - no dates: the last MOVEMENT_EXPORT_DEFAULT_RANGE_DAYS days, whatever else is set;
 * - FROM only: from that day to now;
 * - TO only: the MOVEMENT_EXPORT_DEFAULT_RANGE_DAYS days up to that day.
 * Dates are built in Melbourne time because the backend parses them there.
 */
export const buildMovementExportFilters = (filters, now = moment.tz('Australia/Melbourne')) => {
  if (filters.fromDate) {
    return filters
  }
  const end = filters.toDate ? moment.tz(filters.toDate, 'YYYY-MM-DD', 'Australia/Melbourne') : now

  return {
    ...filters,
    fromDate: end.clone().subtract(MOVEMENT_EXPORT_DEFAULT_RANGE_DAYS, 'days').format('YYYY-MM-DD'),
    toDate: end.clone().format('YYYY-MM-DD'),
  }
}

/** Every movement matching the filters as CSV, one row per page row, streamed by the backend. */
export const exportMovementHistoryCsv = async filters => {
  const query = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== '')
  )
  const response = await superagent
    .get(`${backendUrl}/inventory/movement-history/export`)
    .query(query)
    .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
    .responseType('blob')
  return response.body
}

/** Whether the backend's CSV holds any row below its header line. */
export const csvHasRows = async csv => {
  const text = await csv.text()
  const headerEnd = text.indexOf('\n')
  return headerEnd !== -1 && text.slice(headerEnd + 1).trim().length > 0
}

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
